import { render } from "./OurSolutions.vue?vue&type=template&id=128272e8&scoped=true"
import script from "./OurSolutions.vue?vue&type=script&lang=js"
export * from "./OurSolutions.vue?vue&type=script&lang=js"

import "./OurSolutions.vue?vue&type=style&index=0&id=128272e8&lang=scss&scoped=true"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/theearcasino/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-128272e8"]])

export default __exports__